import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  nestedSideMenuRoot: {
    backdropFilter: "blur(3px)",
    transform: "translateY(0)",
    transition: "transform .7s ease-in-out",
  },

  fieldSectionHeader: {
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "28px",
    color: theme.palette.text.primary,
  },
  fieldSectionInputs: {
    gap: "6px",
    width: "100% !important",
    flexDirection: "column",
  },
  hidden: {
    transform: "translateY(-100%)",
    visibility: "hidden",
    overflow: "hidden",
    opacity: 0,
    height: 0,
  },
}));
